// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"70":"8cfdbd9f723033622dcb","242":"dd3ea8beb0b6101203d1","245":"ea0efe5e36884e1c6e92","453":"4f908a66050961da9696","579":"62ab8cdee07812701358"}[chunkId] + ".js";
};